import React from 'react'
import { Grid } from '@mui/material'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import RuleIcon from '@mui/icons-material/Rule'
import {
  StatsGridContainer,
  StatsCard,
  StatsContentContainer,
  StatsAvatar,
  StatsTextGroup,
  StatsNumberText,
  StatsLabelText,
} from './styled'

const StatsSection = ({ stats }) => {
  return (
    <StatsGridContainer container spacing={2}>
      <Grid item xs={4}>
        <StatsCard>
          <StatsContentContainer>
            <StatsAvatar sx={{ bgcolor: 'primary.main' }}>
              <RuleIcon />
            </StatsAvatar>
            <StatsTextGroup>
              <StatsNumberText variant='h4'>{stats.total}</StatsNumberText>
              <StatsLabelText variant='body2' color='text.secondary'>
                Total Rules
              </StatsLabelText>
            </StatsTextGroup>
          </StatsContentContainer>
        </StatsCard>
      </Grid>
      <Grid item xs={4}>
        <StatsCard>
          <StatsContentContainer>
            <StatsAvatar sx={{ bgcolor: 'success.main' }}>
              <LocalShippingIcon />
            </StatsAvatar>
            <StatsTextGroup>
              <StatsNumberText variant='h4'>{stats.forward}</StatsNumberText>
              <StatsLabelText variant='body2' color='text.secondary'>
                Forward Rules
              </StatsLabelText>
            </StatsTextGroup>
          </StatsContentContainer>
        </StatsCard>
      </Grid>
      <Grid item xs={4}>
        <StatsCard>
          <StatsContentContainer>
            <StatsAvatar sx={{ bgcolor: 'info.main' }}>
              <ContentCopyIcon />
            </StatsAvatar>
            <StatsTextGroup>
              <StatsNumberText variant='h4'>{stats.reverse}</StatsNumberText>
              <StatsLabelText variant='body2' color='text.secondary'>
                Reverse Rules
              </StatsLabelText>
            </StatsTextGroup>
          </StatsContentContainer>
        </StatsCard>
      </Grid>
    </StatsGridContainer>
  )
}

export default StatsSection
